import React from "react";

import { MatxSuspense } from "app/components";
import { useSettings } from "app/hooks/useSettings";
import { MatxLayouts, MatxLayoutsType } from "./index";

const MatxLayout: React.FC = (props) => {
    const { settings } = useSettings();
    const activeLayout = settings.activeLayout;
    const LayoutComponent = (MatxLayouts as MatxLayoutsType)[
        activeLayout as keyof MatxLayoutsType
    ];

    return (
        <MatxSuspense>
            {LayoutComponent && <LayoutComponent {...props} />}
        </MatxSuspense>
    );
};

export default MatxLayout;
